if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.setProductImage(this.dataset.productImage);
      this.setLine1(this.dataset.quantity);
      this.setLine2();
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    setProductImage(imageUrl) {
      const media = this.querySelector('.added-notification__media');
      if (!imageUrl) {
        media.hidden = true;
        return;
      }
      media.hidden = false;
      media.innerHTML = `<img src="${imageUrl}" alt="" width="48" height="48" loading="eager">`;
    }

    /**
     * Line 1: how many of THIS item the submit just added -- distinct
     * from the cart-wide numbers on line 2 below, and on its own line so
     * it never reads as describing the same thing as those (that was the
     * actual source of the confusion this replaced: a bare cart-wide
     * count sitting next to a price read like it described the single
     * item just added).
     */
    setLine1(quantity) {
      const template = this.dataset.line1Template || '';
      const target = this.querySelector('.added-notification__line--added');
      if (quantity) {
        target.textContent = template.replace('__QUANTITY__', quantity);
      } else {
        target.hidden = true;
      }
    }

    /**
     * Line 2: cart subtotal and cart-wide item count, together since
     * they're both "state of the cart now" rather than "what you just
     * did". Both come from DOM the page-header/cart-drawer sections
     * already refreshed (their HTML is fetched and swapped in before
     * this element is created) -- avoids a second network round trip
     * just to read numbers already on the page.
     */
    setLine2() {
      const totalEl = document.querySelector('.js-cart-drawer .subtotal .theme-money');
      const subtotal = totalEl ? totalEl.textContent.trim() : '';
      const countEl = document.querySelector('.cart-link__count');
      const count = countEl ? countEl.textContent.trim() : '';
      const target = this.querySelector('.added-notification__line--summary');

      if (!subtotal || !count) {
        target.hidden = true;
        return;
      }

      // Liquid picks singular/plural wording at render time based on a
      // real number, but this count is only known here, after the
      // add-to-cart response comes back -- so both variants are
      // pre-rendered and this just picks the right one.
      const template = count === '1'
        ? (this.dataset.line2TemplateOne || '')
        : (this.dataset.line2TemplateOther || '').replace('__COUNT__', count);
      target.textContent = template.replace('__SUBTOTAL__', subtotal);
    }

    display() {
      // reveal
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      // dismiss after a short period of time
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 6000);

      // add events to internal links
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));

      const link = this.querySelector('.added-notification__link');
      if (link) {
        link.addEventListener('click', (evt) => {
          if (theme.settings.cartType !== 'drawer') return;
          const drawer = document.querySelector('.js-cart-drawer');
          if (!drawer) return;
          evt.preventDefault();
          drawer.open();
          this.dismiss();
        });
      }
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
